import React from "react";
import { Switch, Button } from "antd";
import { CheckSquareOutlined, CloseOutlined } from "@ant-design/icons";

const columns = [
  {
    title: "BC Product (SKU)",
    dataIndex: "bcSku",
    sorter: (a, b) => a.bcSku.localeCompare(b.bcSku),
    width: 160,
    ellipsis: true,
    render: (_, record) => <Button type="link"></Button>,
    fixed: 'left',
  },
  {
    title: "BC Product Name",
    dataIndex: "bc_name",
    width: 200,
  },
  {
    title: "SAP SKU",
    dataIndex: "sapSku",
    // sorter: (a, b) => a.sapSku.localeCompare(b.sapSku),    
    width: 110,
  },
  {
    title: "SAP Name",
    dataIndex: "sapName",    
    width: 200,
  },
  {
    title: "SAP Customer Number",
    dataIndex: "sapCustomerNumber",
    width: 180,
  },
  {
    title: "Available Stock",
    dataIndex: "availableStock",
    width: 130,
  },
  {
    title: "Reserved Stock",
    dataIndex: "reservedStock",
    width: 130,
  },
  {
    title: "Active on Store",
    dataIndex: "active",
    render: (_, record) => <Switch checked={record.active} />,
    width: 130,
  },
  {
    title: "Store",
    dataIndex: "store",
    width: 70,
  },
  {
    title: "BC Inventory",
    dataIndex: "bcInventory",
    width: 120,
  },
  {
    title: "Subscription",
    dataIndex: "subscription",
    width: 120,
  },
  {
    title: "Enrichment",
    dataIndex: "enrichment",
    width: 110,
    render: (text) =>
      text ? (
        <CheckSquareOutlined style={{ color: "green" }} />
      ) : (
        <CloseOutlined style={{ color: "red" }} />
      ),
  },
  {
    title: "Last Updated",
    dataIndex: "lastUpdated",
    width: 180,
  }
];

export default columns;
